<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Copy Account Templates</h5>
  <button mat-icon-button aria-label="Close dialog" matTooltip="Close this dialog." mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <div class="d-flex py-2 flex-wrap justify-content-between align-items-center">
    <p class="m-0">Select which account you want to copy templates from.</p>
    <button type="button" mat-raised-button class="my-2 mx-0" color="primary" (click)="onSelectAccount()">
      Select Account
    </button>
  </div>

  <div class="pt-2">
    <h6>Selected Account: <span>{{ sourceAccount ? sourceAccount.name : 'Not Selected' }}</span></h6>
    <h6 class="mt-3">Templates</h6>
    <div class="mt-3">
      <mat-radio-group [(ngModel)]="selectedTemplate">
        <p><mat-radio-button value="hazards">Hazards & Risks</mat-radio-button></p>
        <p><mat-radio-button value="hazardous_substances">{{ utils.getLangTerm('hazardous-substances.plural', 'Hazardous
            Substances') }}</mat-radio-button></p>
        <p><mat-radio-button value="site_audits">Inspections & Audits</mat-radio-button></p>
        <p><mat-radio-button value="all">All of the Above</mat-radio-button></p>
      </mat-radio-group>
    </div>
  </div>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-2 py-1">
  <button type="button" mat-raised-button class="my-2 ml-1 mr-2" color="primary"
    [disabled]="!sourceAccountId || inProgress" (click)="onCopyTemplates()">
    Copy Templates
  </button>
</mat-dialog-actions>